import axios, { AxiosInstance } from 'axios';
import { getEnvVar } from '../config/env';

export type RuntimeDataPlaneResponse<T> = { success: boolean; data: T; error?: string };

class RuntimeDataPlaneService {
  private api: AxiosInstance;

  constructor() {
    this.api = axios.create({
      baseURL: `${getEnvVar('VITE_FASTAPI_BASE_URL')}/api/v1/admin/runtime-data-plane`,
      timeout: 30000,
      headers: { 'Content-Type': 'application/json' },
    });
    this.api.interceptors.request.use((config) => {
      const token =
        localStorage.getItem('admin_auth_token') ||
        document.cookie.split('; ').find((r) => r.startsWith('auth_token='))?.split('=')[1];
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
  }

  async getStatus() {
    const { data } = await this.api.get<RuntimeDataPlaneResponse<Record<string, unknown>>>('/status');
    return data;
  }

  async getScreens() {
    const { data } = await this.api.get<RuntimeDataPlaneResponse<unknown[]>>('/screens');
    return data;
  }

  async getScreen(screenId: string, workspaceId?: string) {
    const { data } = await this.api.get<RuntimeDataPlaneResponse<Record<string, unknown>>>(
      `/screens/${encodeURIComponent(screenId)}`,
      { params: workspaceId ? { workspace_id: workspaceId } : undefined }
    );
    return data;
  }

  async getConfiguration() {
    const { data } = await this.api.get<RuntimeDataPlaneResponse<unknown[]>>('/configuration');
    return data;
  }

  async buildReplay(targetTime: string, workspaceId?: string) {
    const { data } = await this.api.post<RuntimeDataPlaneResponse<Record<string, unknown>>>('/replay/build', {
      target_time: targetTime,
      workspace_id: workspaceId,
    });
    return data;
  }
}

export const runtimeDataPlaneService = new RuntimeDataPlaneService();
